module.exports = __webpack_public_path__ + "static/media/the-dutch-7.cb527799.jpg";